import { classNames } from '../utils/UNSAFE_classNames';
import { cssProps } from '@oracle/oraclejet-cssprops';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';

const variantStyles = {
  start: cssProps`${{
    paddingInlineEnd: '2px',
    textAlign: 'start'
  }}`,
  end: cssProps`${{
    paddingInlineStart: '2px',
    textAlign: 'end'
  }}`
};
const displayHiddenStyles = cssProps`${{
  display: 'none'
}}`;

type Props = {
  align?: 'start' | 'end';
  hasMessages?: boolean;
  hasHelp?: boolean;
};

export function InlineRequired({ align = 'end', hasHelp = false, hasMessages = false }: Props) {
  const classes = classNames([
    variantStyles[align],
    (hasHelp || hasMessages) && displayHiddenStyles
  ]);

  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const requiredStr = translations.userAssistance_required();

  return <div class={classes}>{requiredStr}</div>;
}
